// labels

export const marketLabels = {
    ID: 'INDONESIA',
    PH: 'PHILIPPINES',
    CZ: 'Czech Republic',
    US: 'United States'
};
export const categoryLabels = {
    CC: 'CONVENTIONAL CIGARETTES',
};
export const brandLabels = {
    // IQOS: 'IQOS',
    // VEEV: 'VEEV',
    // ZYN: "ZYN",
    // CHESTERFIELD: "CHESTERFIELD"
    MULTI_CATEGORY: 'Multi Category',
};
